import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Apollo, gql } from 'apollo-angular';
import blogQuery from './blog.query';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  // hostname = 'd12981yn7xk356.cloudfront.net';
  hostname = window.location;

  headers: any = new HttpHeaders();
  // .set('content-type', 'application/json')
  // .set('Access-Control-Allow-Origin', '*')
  // .set('Authorization', 'Token 106840a4d1f8d713e2841142ea8d64768964145b')
  // .set('origin', this.hostname.origin)
  // .set('hostname', this.hostname.origin);

  constructor(private _http: HttpClient, private apollo: Apollo) {}

  //All the blogs
  getBlogsData() {
    return this._http
      .get(environment.backend.baseURL + '/blogs/', { headers: this.headers })
      .pipe(
        map((blogs) => blogs['data']),
        shareReplay(1)
      );
  }

  //Search Blogs
  searchBlogsData(arg, filter?) {
    if (filter === 'tags') {
      return this.apollo
        .query({
          query: blogQuery,
          variables: {
            tag: arg,
          },
        })
        .pipe(map((data) => data['data']['blogsGraphql']));
    } else if (filter === 'authors') {
      return this.apollo
        .query({
          query: blogQuery,
          variables: {
            author: arg,
          },
        })
        .pipe(map((data) => data['data']['blogsGraphql']));
    }
    return this.apollo
      .query({
        query: blogQuery,
        variables: {
          search: arg,
        },
      })
      .pipe(map((data) => data['data']['blogsGraphql']));
  }

  //search and pagination Blogs
  PaginationData(pageno: number, searchText: string, filter?) {
    if (searchText.length != 0) {
      if (filter === 'tags') {
        return this.apollo
          .query({
            query: blogQuery,
            variables: {
              offset: (pageno - 1) * 10,
              tag: searchText,
            },
          })
          .pipe(shareReplay(1));
      } else if (filter === 'authors') {
        return this.apollo
          .query({
            query: blogQuery,
            variables: {
              offset: (pageno - 1) * 10,
              author: searchText,
            },
          })
          .pipe(shareReplay(1));
      } else {
        return this.apollo
          .query({
            query: blogQuery,
            variables: {
              offset: (pageno - 1) * 10,
              search: searchText,
            },
          })
          .pipe(shareReplay(1));
      }
    } else {
      return this.apollo
        .query({
          query: blogQuery,
          variables: {
            offset: (pageno - 1) * 10,
          },
        })
        .pipe(shareReplay(1));
    }
  }

  private updateData$ = new BehaviorSubject<void>(void 0);
  readonly sidebarBlogData$ = this.updateData$.pipe(
    switchMap(() =>
      this.apollo.query({
        query: blogQuery,
        variables: {
          limit: 10,
        },
      })
    ),
    shareReplay(1)
  );

  refresh(): void {
    this.updateData$.next();
  }

  updateBlogData$ = new BehaviorSubject<void>(void 0);
  readonly mainBlockdata$ = this.updateBlogData$.pipe(
    switchMap(() =>
      // this._http.get(environment.backend.baseURL + '/blogs/', {
      //   headers: this.headers,
      // })
      this.apollo.query({
        query: blogQuery,
        variables: {},
      })
    ),
    shareReplay()
  );

  // getNewBlogsPaginationData(page: number) {
  //     return this._http.get("https://staging.zscaler.com/jsonapi/blogs/security-research?limit=10&page=" + page, requestOptions)
  //         .pipe(
  //             shareReplay(1)
  //         )
  // }
}
